import { render } from "./ImportPhotoComponent.vue?vue&type=template&id=6c5a98be&scoped=true"
import script from "./ImportPhotoComponent.vue?vue&type=script&lang=js"
export * from "./ImportPhotoComponent.vue?vue&type=script&lang=js"

import "./ImportPhotoComponent.vue?vue&type=style&index=0&id=6c5a98be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5a98be"]])

export default __exports__